<tvcore-alert (close)="clearToast()" [action]="toast.action" [type]="toast.type">
	<span [innerHTML]="getMessage()"></span>
</tvcore-alert>
